import classnames from 'classnames';
import translations from 'constants/experience';
import lang from 'constants/lang';
import styles from './ExperienceARButton.module.scss';

function ExperienceARButton({ className, setPage }) {
  return (
    <div className={ classnames(className, styles.experience) } onClick={ () => { setPage('/artwork/argallery'); } }>
      { translations.experience }{ lang !== 'en' ? <br /> : <span> META-PARADE</span> }
      <div className={ styles.vAlignCenter }>
        { lang !== 'en' && <span>META-PARADE</span> }
        <img src={ `${process.env.PUBLIC_URL}/images/ar.svg` } className={ styles.ar } alt="AR" />
        <span>{ translations.gallery }</span>
        <img src={ `${process.env.PUBLIC_URL}/images/arrow-right.svg` } alt=">" className={ styles.arrowRight } />
      </div>
    </div>
  );
}

export default ExperienceARButton;